import { ReturnSessionResult } from '@cpd-app/core-module/models';

export const authFeatureKey = 'auth';

export interface AuthState {
  token: string;
  isSessionInitializing: boolean;
  isSessionLoaded: boolean;
  errorMessage: string;
  loginWallRedirectUrl: string;
  returnSessionResult: ReturnSessionResult;
  isAuthenticated: boolean;
  isOverPasscode: boolean;
  userId: number;
  username: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  role: string;
  shareToken?: string;
}

export const initialAuthState: AuthState = {
  token: null,
  isSessionInitializing: false,
  isSessionLoaded: false,
  errorMessage: null,
  loginWallRedirectUrl: null,
  returnSessionResult: null,
  isAuthenticated: false,
  isOverPasscode: false,
  userId: null,
  username: null,
  userEmail: null,
  firstName: null,
  lastName: null,
  role: null,
  shareToken: null,
};
